import { useGetApi } from '@hooks/api/useGetApi';
import { scheduleApiKeys, useScheduleApi } from '@hooks/api/useScheduleApi';
import type { VendorScheduleSearchResponse } from '@services/api/types';

export function useOrganizationAppointments(organizationId: string) {
  const api = useScheduleApi();
  return useGetApi<VendorScheduleSearchResponse>({
    enabled: !!organizationId,
    queryKey: scheduleApiKeys.getOrganizationAppointments(organizationId),
    request: () =>
      api.getOrganizationAppointments({ vendorOrganizationId: organizationId }),
  });
}
